export default "__VITE_ASSET__0mWBoQnX__"